import type { PositionSizeRule } from '@einhaus/project314-types';
import { PositionSizeRulesEditor } from '@/pages/User/PortfolioBacktest/PortfolioBacktestCapitalControls';
import { summarizePositionSizeRules } from '@/utils/capitalRuleFormatters';

interface LiveStrategyPositionSizingProps {
    portfolioRules: PositionSizeRule[];
    rules: PositionSizeRule[] | undefined;
    onChange: (rules: PositionSizeRule[] | undefined) => void;
}

const buildInitialStrategyRules = (portfolioRules: PositionSizeRule[]): PositionSizeRule[] =>
    portfolioRules.length > 0
        ? structuredClone(portfolioRules)
        : [
              {
                  id: `live-strategy-size-${Date.now().toString()}`,
                  type: 'fixed',
                  entityTypes: ['Asset'],
                  value: 10000
              }
          ];

export const LiveStrategyPositionSizing = ({ portfolioRules, rules, onChange }: LiveStrategyPositionSizingProps) => {
    if (rules === undefined) {
        return (
            <div className="rounded border border-zinc-700 bg-zinc-900/50 p-3">
                <div className="flex flex-wrap items-start justify-between gap-2">
                    <div>
                        <div className="text-sm font-medium text-zinc-100">Position sizing</div>
                        <div className="text-xs text-zinc-400">Using portfolio sizing · {summarizePositionSizeRules(portfolioRules)}</div>
                    </div>
                    <button
                        className="rounded bg-zinc-700 px-3 py-1 text-xs text-zinc-100 hover:bg-zinc-600"
                        type="button"
                        onClick={() => onChange(buildInitialStrategyRules(portfolioRules))}
                    >
                        Customize for this strategy
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="space-y-2">
            <div className="flex justify-end">
                <button
                    className="rounded bg-zinc-700 px-3 py-1 text-xs text-zinc-100 hover:bg-zinc-600"
                    type="button"
                    onClick={() => onChange(undefined)}
                >
                    Use portfolio sizing
                </button>
            </div>
            <PositionSizeRulesEditor
                description="Overrides portfolio sizing for matching entity types on this strategy only. Other entity types fall back to the portfolio. Portfolio-wide position limits and safeguards still apply."
                rules={rules}
                title="Strategy position sizing"
                onChange={onChange}
            />
        </div>
    );
};
